import './Header.css'
import image from './my.jpg'
function Header() {
    return (
      <div className="Header">       
        <div className='container'>
          <div className="image"><img src={image}/></div>
          <div className="text">Designing the future, from data to decision!</div>
        </div>
        <a className='btn' href='#footer'>LET'S CONNECT W/ ME</a>
      </div>
      
    );
  }
  
export default Header;